import { PaymentRequest, BillingAddressDetails } from './types';

export enum ActionType {
    SetHasInvalidCode = "SET_HAS_INVALID_CODE",
    SetPaymentRequest = "SET_PAYMENT_REQUEST",
    SetHasBillingAddress = "SET_HAS_BILLING_ADDRESS",
    SetHasBillingAddressError = "SET_HAS_BILLING_ADDRESS_ERROR",
    SetBillingAddressDetails = "SET_BILLING_ADDRESS_DETAILS",
    SetTransactionUrl = "SET_TRANSACTION_URL"
}

type SetHasInvalidCodeState = {
    type: ActionType.SetHasInvalidCode;
    hasInvalidCode: boolean;
}

type SetPaymentRequestState = {
    type: ActionType.SetPaymentRequest;
    paymentRequest?: PaymentRequest;
}

type SetHasBillingAddressState = {
    type: ActionType.SetHasBillingAddress;
    isBillingAddressSet: boolean;
}

type SetHasBillingAddressErrorState = {
    type: ActionType.SetHasBillingAddressError;
    hasBillingAddressError: boolean;
}

type SetBillingAddressDetailsState = {
    type: ActionType.SetBillingAddressDetails;
    billingAddressDetails:BillingAddressDetails
}

type SetTransactionUrlState = {
    type: ActionType.SetTransactionUrl;
    transactionUrl: string;
}

export type Actions = SetHasInvalidCodeState | SetPaymentRequestState | SetHasBillingAddressState | SetHasBillingAddressErrorState | SetBillingAddressDetailsState | SetTransactionUrlState;

export const setHasInvalidCode = (hasInvalidCode: boolean): SetHasInvalidCodeState => ({
    type: ActionType.SetHasInvalidCode,
    hasInvalidCode
});

export const setPaymentRequest = (paymentRequest?: PaymentRequest): SetPaymentRequestState => ({
    type: ActionType.SetPaymentRequest,
    paymentRequest
});

export const setHasBillingAddress = (isBillingAddressSet: boolean): SetHasBillingAddressState => ({
    type: ActionType.SetHasBillingAddress,
    isBillingAddressSet
});

export const setHasBillingAddressError = (hasBillingAddressError: boolean): SetHasBillingAddressErrorState => ({
    type: ActionType.SetHasBillingAddressError,
    hasBillingAddressError
});

export const setBillingAddressDetails = (billingAddressDetails: BillingAddressDetails): SetBillingAddressDetailsState => ({
    type: ActionType.SetBillingAddressDetails,
    billingAddressDetails
});

export const setTransactionUrl = (transactionUrl: string): SetTransactionUrlState => ({
    type: ActionType.SetTransactionUrl,
    transactionUrl
});
